import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
// import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';

import { useMintImportSharedState } from './mintImportSharedState';

const steps = [
  {
    key: 'TAGS',
    label: 'Tags',
    icon: SellOutlinedIcon,
  },
  {
    key: 'CATEGORIES',
    label: 'Categories',
    icon: CategoryIcon,
  },
  {
    key: 'LOGINS',
    label: 'Logins',
    icon: AccountBalanceOutlinedIcon,
  },
  {
    key: 'ACCOUNTS',
    label: 'Accounts',
    icon: AccountTreeOutlinedIcon,
  },
  {
    key: 'TRANSACTIONS',
    label: 'Transactions',
    icon: ReceiptLongOutlinedIcon,
  },
  {
    key: 'BALANCES',
    label: 'Balances',
    icon: AutoGraphOutlinedIcon,
  },
  {
    //   key: 'HOLDINGS',
    //   label: 'Balances',
    //   icon: RequestQuoteOutlinedIcon,
    // }, {
    key: 'COMPLETE',
    label: 'Complete',
    icon: CelebrationOutlinedIcon,
  },
];

const StepIconComponent = (props) => {
  const { icon, active, completed, progress, error } = props;
  return (
    <Box display='flex' justifyContent='center' alignItems='center'>
      <IconButton disabled={completed}>
        <Icon component={icon} sx={{ width: 32, height: 32 }} {...(error && { color: 'error' })} />
      </IconButton>

      {completed && !error ? (
        <CheckCircleOutlineOutlinedIcon color='success' sx={{ position: 'absolute', width: 60, height: 60 }} />
      ) : (
        <CircularProgress size={48} variant='determinate' value={active ? progress : 0} sx={{ position: 'absolute' }} />
      )}
    </Box>
  );
};
StepIconComponent.propTypes = {
  icon: PropTypes.object,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  error: PropTypes.bool,
  progress: PropTypes.number,
};

const ImportFromMint = () => {
  const [mintImport] = useMintImportSharedState();
  const [activeStep, progress] = useMemo(() => {
    const step = steps.findIndex((aStep) => aStep.key === mintImport.key);
    return [step, mintImport.progress];
  }, [mintImport]);

  return (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'center', paddingTop: 150 }}>
      <Stepper orientation='horizontal' activeStep={activeStep} sx={{ flexDirection: 'row' }}>
        {steps.map(({ key, label, icon }) => (
          <Step key={key} sx={{ paddingRight: 0 }}>
            <StepLabel
              StepIconComponent={StepIconComponent}
              StepIconProps={{ icon, progress }}
              error={mintImport.error === key}
              // StepIconProps={{ icon, progress, error: mintImport.error }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default ImportFromMint;
